export const regExpToString = (expression: RegExp): string =>
  `/${expression.source}/${expression.flags}`;
